import React, { useEffect, useRef, useState } from "react";
import Header from "../../../Componets/Header";
import { get_all_inventory_adjustments } from "../../../Controllers/Inventory/Adjustment";
import toast from "react-hot-toast";
import moment from "moment";
import Loadercomponent from "../../../Componets/Loader";
import ReactToPrint from "react-to-print";
import { Button, Drawer } from "antd";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { registerCairoFont } from "../cairo-font";
import ScrollWrapper from "../../../Componets/ScrollWrapper";

const InventoryAdjustmentReport = () => {
    let componentRef = useRef();

    const [loader, setLoader] = useState(false);
    const [body, setBody] = useState([]);
    const [drawer, setDrawer] = useState(false);
    const [selected, setSelected] = useState(null);

    const [summary, setSummary] = useState({
        total: 0,
        total_qty: 0,
        total_value_lost: 0,
        damage: { count: 0, qty: 0, value: 0 },
        wastage: { count: 0, qty: 0, value: 0 },
        expired: { count: 0, qty: 0, value: 0 },
    });

    const headers = {
        name: "Adjustment Report",
        components: [
            {
                type: "search",
                name: "search",
                placeholder: "Search",
                value: "",
            },
            {
                type: "select",
                name: "sort",
                placeholder: "Sort",
                value: null,
                allowClear: true,
                options: [
                    { value: 1, label: "Date (Newest)" },
                    { value: 2, label: "Date (Oldest)" },
                    { value: 3, label: "Quantity (Low)" },
                    { value: 4, label: "Quantity (High)" },
                ],
            },
            {
                type: "filter",
                name: "type",
                placeholder: "Type",
                allowClear: true,
                value: null,
                options: [
                    { value: "damage", label: "Damage" },
                    { value: "wastage", label: "Wastage" },
                    { value: "expired", label: "Expired" },
                ],
            },
            {
                type: "filter",
                name: "branch",
                allowClear: true,
                showSearch: true,
                filterOption: false,
                placeholder: "Branch",
                api: "get-all-branches",
                value: null,
                options: null,
            },
            {
                type: "range",
                name: "date",
                value: { start: "", end: "" },
            },
        ],
        navigate: {
            tabs: [
                { name: "Reports", path: "/app/reports" },
                { name: "Inventory", path: "/app/reports/inventory" },
                { name: "Adjustment", path: "" },
            ],
            total: [
                { value: 0, label: "Total" },
                { value: 0, label: "Damage" },
                { value: 0, label: "Wastage" },
                { value: 0, label: "Expired" },
            ],
        },
    };

    const [header, setHeader] = useState(headers);

    const formdata = (data) => fetchData(data);

    const computeSummary = (rows) => {
        const s = {
            total: rows?.length || 0,
            total_qty: 0,
            total_value_lost: 0,
            damage: { count: 0, qty: 0, value: 0 },
            wastage: { count: 0, qty: 0, value: 0 },
            expired: { count: 0, qty: 0, value: 0 },
        };

        rows?.forEach((row) => {
            const qty = parseFloat(row?.quantity || 0);
            const value_lost = qty * parseFloat(row?.inventory?.purchase_price || 0);
            const type = row?.type;

            if (s[type]) {
                s[type].count++;
                s[type].qty += qty;
                s[type].value += value_lost;
            }

            s.total_qty += qty;
            if (type !== "return") s.total_value_lost += value_lost;
        });

        return s;
    };

    const fetchData = async (tabledata) => {
        try {
            setLoader(true);

            const result = await get_all_inventory_adjustments({
                search: tabledata?.search,
                sort: tabledata?.sort,
                type: tabledata?.type,
                branch: tabledata?.branch,
                date: tabledata?.date,
                page: 1,
                limit: 10000,
            });

            if (result?.status) {
                const rows = result?.data?.data;
                setBody(rows);
                setSummary(computeSummary(rows));
                setLoader(false);
            } else {
                toast?.error(result?.message);
                setLoader(false);
            }
        } catch (errors) {
            toast?.error(errors?.message);
        }
    };

    const typeColor = (type) => ({
        damage: "text-red-600",
        wastage: "text-orange-600",
        expired: "text-yellow-600",
    }[type] || "");

    const typeBg = (type) => ({
        damage: "bg-red-50 border-red-200",
        wastage: "bg-orange-50 border-orange-200",
        expired: "bg-yellow-50 border-yellow-200",
    }[type] || "");

    const downloadCSV = () => {
        if (!body || body.length === 0) {
            toast.error("No data to download");
            return;
        }

        const headerRow = [
            "S.No", "Date", "Batch", "Product", "Supplier",
            "Type", "Quantity", "Stock Before", "Stock After",
            "Purchase Price", "Value Lost", "Reason", "Note", "Created By",
        ];

        const rows = body.map((item, index) => [
            index + 1,
            moment(item?.date).format("DD/MM/YYYY"),
            `#BATCH-${item?.inventory?.number}`,
            item?.inventory?.product?.name || "-",
            item?.inventory?.supplier?.name || "-",
            item?.type,
            item?.quantity,
            parseFloat(item?.stock_before),
            parseFloat(item?.stock_after),
            parseFloat(item?.inventory?.purchase_price || 0)?.toFixed(3),
            (parseFloat(item?.quantity || 0) * parseFloat(item?.inventory?.purchase_price || 0))?.toFixed(3),
            item?.reason || "-",
            item?.note || "-",
            item?.created_by?.name || "-",
        ]);

        const csvContent = [headerRow, ...rows]
            .map((row) => row.map((f) => `"${f}"`).join(","))
            .join("\n");

        const blob = new Blob(
            [new TextEncoder().encode("\uFEFF" + csvContent)],
            { type: "text/csv;charset=utf-8" }
        );
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `Adjustment_Report_${moment().format("DD_MM_YYYY")}.csv`;
        link.style.display = "none";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    const downloadPDF = () => {
        if (!body || body.length === 0) return;

        const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });
        registerCairoFont(doc);

        const pageWidth = doc.internal.pageSize.getWidth();
        doc.setFont("Cairo-Bold", "bold");
        doc.setFontSize(16);
        doc.text("Inventory Adjustment Report", pageWidth / 2, 10, { align: "center" });

        const now = new Date();
        doc.setFontSize(8);
        doc.text(
            `Downloaded on: ${now.toLocaleDateString("en-GB")} ${now.toLocaleTimeString()}`,
            pageWidth / 2, 16, { align: "center" }
        );

        // summary block in PDF
        doc.setFontSize(9);
        doc.text(`Total Adjustments: ${summary?.total}`, 5, 24);
        doc.text(`Total Qty Lost: ${summary?.total_qty}`, 60, 24);
        doc.text(`Total Value Lost: OMR ${summary?.total_value_lost?.toFixed(3)}`, 120, 24);

        autoTable(doc, {
            margin: { left: 5, right: 5 },
            startY: 30,
            head: [[
                "S.No", "Date", "Batch", "Product", "Supplier",
                "Type", "Qty", "Before", "After",
                "Purch. Price", "Value Lost", "Reason", "By",
            ]],
            body: body.map((item, index) => [
                index + 1,
                moment(item?.date).format("DD/MM/YYYY"),
                `#BATCH-${item?.inventory?.number}`,
                item?.inventory?.product?.name || "-",
                item?.inventory?.supplier?.name || "-",
                item?.type,
                item?.quantity,
                parseFloat(item?.stock_before),
                parseFloat(item?.stock_after),
                parseFloat(item?.inventory?.purchase_price || 0)?.toFixed(3),
                (parseFloat(item?.quantity || 0) * parseFloat(item?.inventory?.purchase_price || 0))?.toFixed(3),
                item?.reason || "-",
                item?.created_by?.name || "-",
            ]),
            styles: { font: "Cairo", textColor: [0, 0, 0], lineColor: [7, 181, 83], lineWidth: 0.2 },
            headStyles: { font: "Cairo", fontStyle: "bold", fillColor: false, lineColor: [7, 181, 83], lineWidth: 0.6, fontSize: 8 },
            bodyStyles: { fontSize: 6 },
            columnStyles: { 3: { cellWidth: 30 }, 11: { cellWidth: 35 } },
        });

        doc.save(`Adjustment_Report_${moment().format("DD_MM_YYYY")}.pdf`);
    };

    useEffect(() => { fetchData(); }, []);

    return (
        <Header headers={header} setHeaders={setHeader} formdata={formdata}>
            <Loadercomponent loader={loader}>

                <div className="grid grid-cols-2 gap-4 p-4 mb-4">

                    <div className="bg-white rounded-md border p-4">
                        <div className="text-xs text-gray-500 mb-3 uppercase tracking-wide font-medium">
                            Overview
                        </div>
                        <div className="grid grid-cols-3 gap-4">
                            <div>
                                <div className="text-2xl font-semibold">{summary?.total}</div>
                                <div className="text-xs text-gray-500">Total Adjustments</div>
                            </div>
                            <div>
                                <div className="text-2xl font-semibold">
                                    {summary?.total_qty}
                                </div>
                                <div className="text-xs text-gray-500">Total Qty Lost</div>
                            </div>
                            <div>
                                <div className="text-2xl font-semibold text-red-600">
                                    OMR {summary?.total_value_lost?.toFixed(3)}
                                </div>
                                <div className="text-xs text-gray-500">Total Value Lost</div>
                            </div>
                        </div>
                    </div>

                    <div className="grid grid-cols-3 gap-3">
                        {["damage", "wastage", "expired"].map((type) => (
                            <div
                                key={type}
                                className={`rounded-md border p-3 ${typeBg(type)}`}
                            >
                                <div className={`text-xs font-semibold capitalize mb-2 ${typeColor(type)}`}>
                                    {type}
                                </div>
                                <div className="text-lg font-semibold">
                                    {summary?.[type]?.qty || "0.000"}
                                </div>
                                <div className="text-xs text-gray-500">
                                    {summary?.[type]?.count || 0} records
                                </div>
                                <div className={`text-xs font-medium mt-1 ${typeColor(type)}`}>
                                    OMR {summary?.[type]?.value?.toFixed(3) || "0.000"}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* ── Download buttons ────────────────────────────────────────── */}
                <div className="flex gap-3 justify-end mb-4 px-4">
                    <Button
                        className="text-medium form-save-button"
                        type="primary"
                        onClick={downloadCSV}
                    >
                        Download CSV
                    </Button>
                    <Button
                        className="text-medium form-save-button"
                        type="primary"
                        onClick={downloadPDF}
                    >
                        Download PDF
                    </Button>
                </div>

                <ScrollWrapper>
                    <div
                        className="max-h-[60vh] overflow-y-auto scrollbar-hide remove-scroll-limit"
                        ref={(el) => (componentRef = el)}
                    >
                        <table className="w-full bg-white">
                            <thead className="text-gray-500 sticky top-0 bg-white z-10">
                                <tr className="text-sm">
                                    <td className="border p-4">S.No</td>
                                    <td className="border p-4">Date</td>
                                    <td className="border p-4">Batch</td>
                                    <td className="border p-4">Product</td>
                                    <td className="border p-4">Supplier</td>
                                    <td className="border p-4">Type</td>
                                    <td className="border p-4">Quantity</td>
                                    <td className="border p-4">Before</td>
                                    <td className="border p-4">After</td>
                                    <td className="border p-4">Purch.&nbsp;Price</td>
                                    <td className="border p-4">Value&nbsp;Lost</td>
                                    <td className="border p-4">Reason</td>
                                    <td className="border p-4">By</td>
                                </tr>
                            </thead>
                            <tbody>
                                {body?.map((value, index) => {
                                    const value_lost =
                                        parseFloat(value?.quantity || 0) *
                                        parseFloat(value?.inventory?.purchase_price || 0);

                                    return (
                                        <tr
                                            key={index}
                                            className="text-xs hover:bg-gray-50 cursor-pointer"
                                            onClick={() => { setSelected(value); setDrawer(true); }}
                                        >
                                            <td className="border p-4">{index + 1}</td>
                                            <td className="border p-4 whitespace-nowrap">
                                                {moment(value?.date).format("DD/MM/YYYY")}
                                            </td>
                                            <td className="border p-4 whitespace-nowrap">
                                                #BATCH-{value?.inventory?.number}
                                            </td>
                                            <td className="border p-4">
                                                {value?.inventory?.product?.name}
                                            </td>
                                            <td className="border p-4">
                                                {value?.inventory?.supplier?.name || "-"}
                                            </td>
                                            <td className={`border p-4 capitalize font-medium ${typeColor(value?.type)}`}>
                                                {value?.type}
                                            </td>
                                            <td className="border p-4">{value?.quantity}</td>
                                            <td className="border p-4">
                                                {parseFloat(value?.stock_before)}
                                            </td>
                                            <td className="border p-4">
                                                {parseFloat(value?.stock_after)}
                                            </td>
                                            <td className="border p-4">
                                                {parseFloat(value?.inventory?.purchase_price || 0)?.toFixed(3)}
                                            </td>
                                            <td className={`border p-4 font-medium ${value?.type !== "return" ? "text-red-600" : "text-green-600"}`}>
                                                {value?.type !== "return"
                                                    ? value_lost?.toFixed(3)
                                                    : "-"}
                                            </td>
                                            <td className="border p-4">{value?.reason}</td>
                                            <td className="border p-4">
                                                {value?.created_by?.name || "-"}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                            <tfoot className="sticky bottom-0 bg-white z-10">
                                <tr className="text-sm font-medium">
                                    <td className="border p-4 text-medium" colSpan={6}>TOTAL</td>
                                    <td className="border p-4 text-medium">
                                        {summary?.total_qty}
                                    </td>
                                    <td className="border p-4"></td>
                                    <td className="border p-4"></td>
                                    <td className="border p-4"></td>
                                    <td className="border p-4 text-medium text-red-600">
                                        {summary?.total_value_lost?.toFixed(3)}
                                    </td>
                                    <td className="border p-4"></td>
                                    <td className="border p-4"></td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </ScrollWrapper>

                <Drawer
                    title="Adjustment Detail"
                    placement="right"
                    width={420}
                    open={drawer}
                    onClose={() => { setDrawer(false); setSelected(null); }}
                >
                    {selected && (
                        <div className="text-sm space-y-4">

                            {/* Type badge */}
                            <div className={`inline-block px-3 py-1 rounded-full text-xs font-semibold capitalize ${typeBg(selected?.type)} ${typeColor(selected?.type)}`}>
                                {selected?.type}
                            </div>

                            {/* Inventory info */}
                            <div className="border rounded-md p-4 space-y-2">
                                <div className="text-xs text-gray-400 uppercase font-medium mb-2">
                                    Inventory
                                </div>
                                <div className="flex justify-between">
                                    <span className="text-gray-500">Batch</span>
                                    <span className="font-medium">#BATCH-{selected?.inventory?.number}</span>
                                </div>
                                <div className="flex justify-between">
                                    <span className="text-gray-500">Product</span>
                                    <span className="font-medium">{selected?.inventory?.product?.name}</span>
                                </div>
                                <div className="flex justify-between">
                                    <span className="text-gray-500">Supplier</span>
                                    <span>{selected?.inventory?.supplier?.name || "-"}</span>
                                </div>
                                <div className="flex justify-between">
                                    <span className="text-gray-500">Purchase Price</span>
                                    <span>OMR {parseFloat(selected?.inventory?.purchase_price || 0)?.toFixed(3)}</span>
                                </div>
                            </div>

                            {/* Stock movement */}
                            <div className="border rounded-md p-4 space-y-2">
                                <div className="text-xs text-gray-400 uppercase font-medium mb-2">
                                    Stock Movement
                                </div>
                                <div className="flex justify-between">
                                    <span className="text-gray-500">Quantity Adjusted</span>
                                    <span className="font-semibold text-red-600">
                                        -{selected?.quantity}
                                    </span>
                                </div>
                                <div className="flex justify-between">
                                    <span className="text-gray-500">Stock Before</span>
                                    <span>{parseFloat(selected?.stock_before)}</span>
                                </div>
                                <div className="flex justify-between">
                                    <span className="text-gray-500">Stock After</span>
                                    <span className="font-semibold">
                                        {parseFloat(selected?.stock_after)}
                                    </span>
                                </div>
                                <div className="flex justify-between border-t pt-2">
                                    <span className="text-gray-500">Value Lost</span>
                                    <span className="font-semibold text-red-600">
                                        {selected?.type !== "return"
                                            ? `OMR ${(parseFloat(selected?.quantity || 0) * parseFloat(selected?.inventory?.purchase_price || 0))?.toFixed(3)}`
                                            : "-"}
                                    </span>
                                </div>
                            </div>

                            {/* Reason & notes */}
                            <div className="border rounded-md p-4 space-y-2">
                                <div className="text-xs text-gray-400 uppercase font-medium mb-2">
                                    Details
                                </div>
                                <div>
                                    <div className="text-gray-500 mb-1">Reason</div>
                                    <div className="text-sm">{selected?.reason || "-"}</div>
                                </div>
                                {selected?.note && (
                                    <div className="pt-2">
                                        <div className="text-gray-500 mb-1">Notes</div>
                                        <div className="text-sm text-gray-700">{selected?.note}</div>
                                    </div>
                                )}
                            </div>

                            {/* Image */}
                            {selected?.image && (
                                <div className="border rounded-md p-4">
                                    <div className="text-xs text-gray-400 uppercase font-medium mb-2">
                                        Attached Image
                                    </div>
                                    <img
                                        src={selected?.image}
                                        alt="adjustment"
                                        className="w-full rounded-md object-cover max-h-[200px]"
                                    />
                                </div>
                            )}

                            {/* Audit trail */}
                            <div className="border rounded-md p-4 space-y-2">
                                <div className="text-xs text-gray-400 uppercase font-medium mb-2">
                                    Audit
                                </div>
                                <div className="flex justify-between">
                                    <span className="text-gray-500">Created By</span>
                                    <span>{selected?.created_by?.name || "-"}</span>
                                </div>
                                <div className="flex justify-between">
                                    <span className="text-gray-500">Date</span>
                                    <span>{moment(selected?.date)?.format("DD/MM/YYYY")}</span>
                                </div>
                                <div className="flex justify-between">
                                    <span className="text-gray-500">Branch</span>
                                    <span>{selected?.branch?.name || "-"}</span>
                                </div>
                            </div>

                        </div>
                    )}
                </Drawer>

            </Loadercomponent>
        </Header>
    );
};

export default InventoryAdjustmentReport;